import { Link } from 'react-router-dom';
import {ArrowBack} from "@mui/icons-material"

// material-ui
import { useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery } from '@mui/material';
import { Box, width } from '@mui/system';
import { deepPurple } from '@mui/material/colors';

// project imports

// assets

// ================================|| AUTH3 - LOGIN ||================================ //

const PageNotFound = () => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box sx={{
            width : "100%",
            height : "100vh",
            display:"flex",
            flexDirection:"column",
            alignItems:"center",
            justifyContent:"center",
            }}>
            <Typography sx={{
                fontSize:"50px",
                marginBottom:"30px"
            }}>
                This page does not exist.
            </Typography>
            <Link to="/home" style={{
                    display:"inline-flex",
                    alignItems:"center",
                    gap:"5px",
                    marginBottom:"30px",
                    textDecoration:"none",
                    color:deepPurple[500]
                }}>
                    <ArrowBack/>
                    Go Back
            </Link>
        </Box>
        

    );
};

export default PageNotFound;
